import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/config';
import { baseQueryWithInterceptor } from '../../utils/baseQueryWithInterceptor';

export type ReactionType = 'LIKE' | 'DISLIKE';

export interface ToggleReactionResponse {
  action: 'added' | 'removed' | 'changed';
  reaction?: {
    id: string;
    userId: string;
    postId: string;
    type: ReactionType;
  };
}

const postReactionApi = createApi({
  reducerPath: 'postReactionApi',
  baseQuery: baseQueryWithInterceptor(`${config.API_BASE_URL}/post-reaction`),
  tagTypes: ['reaction'],

  endpoints: (builder) => ({
    // NEW: Consolidated toggle endpoint (fixes gamification bug)
    togglePostReaction: builder.mutation<
      ToggleReactionResponse,
      { postId: string; reactionType: ReactionType }
    >({
      query: ({ postId, reactionType }) => ({
        url: '/toggle',
        method: 'POST',
        body: { postId, reactionType },
      }),
      invalidatesTags: ['reaction'],
    }),
  }),
});

export const { useTogglePostReactionMutation } = postReactionApi;

export default postReactionApi;
